module.exports = __webpack_public_path__ + "img/强阵雨.e7041c5d.png";